'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Checkbox } from '@common/components';
import { SvgNotificationAlarm } from '@common/icon';
import { useState } from 'react';
import { closeResponsiveDialog } from '@/stores/ResponsiveDialogStore';
interface BenefitConsentSheetProps {
  /** 동의 완료 후 원래 하려던 리워드 행위를 이어간다. */
  onAgree: () => Promise<unknown>;
}

//* S8 알림동의 시트. 보상 수령 직전 혜택알림(마케팅 수신동의)이 없으면 게이트가 연다.
export const BenefitConsentSheet = t0 => {
  const $ = _c(14);
  const {
    onAgree
  } = t0;
  const [isChecked, setIsChecked] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-4"><h2 className="font-700 text-Gray-900 typo-h7">혜택 알림을 받을까요?</h2><p className="text-Gray-600 typo-body4">출석, 행운권, 걸음 보상 소식을 놓치지 않게 알려드려요.</p></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex justify-center py-8"><SvgNotificationAlarm className="size-80 text-Y-400" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isChecked) {
    t3 = <Checkbox checked={isChecked} onCheckedChange={setIsChecked}>[선택] 혜택 · 광고성 정보 수신 동의</Checkbox>;
    $[2] = isChecked;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button theme="sub-line" className="flex-1" onClick={closeResponsiveDialog}>다음에 하기</Button>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !isChecked;
  let t6;
  if ($[5] !== onAgree) {
    t6 = () => {
      setIsSubmitting(true);
      onAgree().catch(() => {
        setIsSubmitting(false);
      });
    };
    $[5] = onAgree;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isSubmitting || $[8] !== t5 || $[9] !== t6) {
    t7 = <div className="flex gap-8">{t4}<Button className="flex-1" loading={isSubmitting} disabled={t5} onClick={t6}>동의하고 계속</Button></div>;
    $[7] = isSubmitting;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t3 || $[12] !== t7) {
    t8 = <div className="flex flex-col gap-24 px-20 pb-20 pt-8">{t1}{t2}{t3}{t7}</div>;
    $[11] = t3;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};